module.exports = __webpack_public_path__ + "static/fonnor@2x-0c5877dc6f562957d0318ed281b8a702.png";